export default __webpack_public_path__ + "locales/lv/DataReassignmentDialog.json?hash=2fb9d51bd7606e9565372c1144edbbd2";